import {Component, OnInit} from '@angular/core';
import {BikeRack} from '../../../../types/models';
import {DirectoryService} from '../../../../services/directory.service';
import {UrlService} from '../../../../services/url.service';
import {AbstractListComponent} from '../abstract-list.component';
import {EmptyRowService} from '../../../../services/empty-row.service';

@Component({
    selector: 'bike-racks-list',
    templateUrl: './bike-racks-list.component.html'
})
export class BikeRacksListComponent extends AbstractListComponent implements OnInit {

    constructor(
        public directoryService: DirectoryService,
        public urlService: UrlService,
        public emptyRowService: EmptyRowService
    ) {
        super(directoryService, urlService, emptyRowService);
    }

    ngOnInit() {
        super.ngOnInit();
        this.s.push(this.directoryService.onDataReceived.subscribe((response) => {
            if (response.id !== 'bike-racks') return;
            const entities = response.data.entities || [];
            this.data = entities.map((data) => {
                const bikeRack = BikeRack.fromExistingData(data);
                const selItem = this.directoryService.selectedItemData;
                if (selItem && selItem.id == data.id) {
                    bikeRack.checked = true;
                    this.directoryService.toggleDetailedView(bikeRack, true);
                }
                return bikeRack;
            });
            this.fillEmptyRow();
        }));
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/directory/list/bike-racks-list/bike-racks-list.component.ts